export default "__VITE_ASSET__DEIWJT2J__"